// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.replaceImageButton_Gkflj{
    display : inline !important;
    margin-right: 5px;
}

.replaceImageButton_Gkflj > span{
    margin-left: 10px
}

.deleteImageLink_hNMb5{
    display : inline !important;
    margin-left : 5px;
}

.imagePreviewContainer_S7n0V{
    background: #FFFFFF;
    border: 1px solid #CED6DE;
    box-sizing: border-box;
    border-radius: 8px;
    height: 75px;
    width: 100%;
    margin-bottom: 8px;
}

.imagePreview_PSZ7t{
    max-height: 100%;
    display : inline;
}

.imageInfo_Fj2Bz{
    display : inline-block;
    vertical-align: top;
    height: 100%;
    padding-top: 15px;
    padding-left: 5px;
    max-width: 250px;
}

.imageFilename_XUprx{
    
}

.imageSize_zPzDu{

}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/r4k/views/installGateway/ImageInput.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;;AAEA","sourcesContent":[".replaceImageButton{\n    display : inline !important;\n    margin-right: 5px;\n}\n\n.replaceImageButton > span{\n    margin-left: 10px\n}\n\n.deleteImageLink{\n    display : inline !important;\n    margin-left : 5px;\n}\n\n.imagePreviewContainer{\n    background: #FFFFFF;\n    border: 1px solid #CED6DE;\n    box-sizing: border-box;\n    border-radius: 8px;\n    height: 75px;\n    width: 100%;\n    margin-bottom: 8px;\n}\n\n.imagePreview{\n    max-height: 100%;\n    display : inline;\n}\n\n.imageInfo{\n    display : inline-block;\n    vertical-align: top;\n    height: 100%;\n    padding-top: 15px;\n    padding-left: 5px;\n    max-width: 250px;\n}\n\n.imageFilename{\n    \n}\n\n.imageSize{\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"replaceImageButton": `replaceImageButton_Gkflj`,
	"deleteImageLink": `deleteImageLink_hNMb5`,
	"imagePreviewContainer": `imagePreviewContainer_S7n0V`,
	"imagePreview": `imagePreview_PSZ7t`,
	"imageInfo": `imageInfo_Fj2Bz`,
	"imageFilename": `imageFilename_XUprx`,
	"imageSize": `imageSize_zPzDu`
};
export default ___CSS_LOADER_EXPORT___;
